import type { SpeculationRulesSchema } from './types';

export const DEFAULT_SETTINGS: SpeculationRulesSchema = {
    prerender: [
        {
            where: {
                and: [
                    { selector_matches: '[data-specrule="prerender"]' },
                    { selector_matches: '[data-eagerness="moderate"]' },
                ],
            },
            eagerness: 'moderate',
        },
        {
            where: {
                and: [
                    { selector_matches: '[data-specrule="prerender"]' },
                    { selector_matches: '[data-eagerness="conservative"]' },
                ],
            },
            eagerness: 'conservative',
        },
        {
            where: {
                and: [
                    { selector_matches: '[data-specrule="prerender"]' },
                    { selector_matches: '[data-eagerness="immediate"]' },
                ],
            },
            eagerness: 'immediate',
        },
    ],
    prefetch: [
        {
            where: {
                and: [
                    { selector_matches: '[data-specrule="prefetch"]' },
                    { selector_matches: '[data-eagerness="moderate"]' },
                ],
            },
            eagerness: 'moderate',
        },
        {
            where: {
                and: [
                    { selector_matches: '[data-specrule="prefetch"]' },
                    { selector_matches: '[data-eagerness="conservative"]' },
                ],
            },
            eagerness: 'conservative',
        },
        {
            where: {
                and: [
                    { selector_matches: '[data-specrule="prefetch"]' },
                    { selector_matches: '[data-eagerness="immediate"]' },
                ],
            },
            eagerness: 'immediate',
        },
    ],
};

export const PAGE_SCHEMAS: { page: string; schema: SpeculationRulesSchema }[] = [
    {
        page: '/',
        schema: {
            prerender: [
                {
                    where: {
                        and: [{ href_matches: ['/price/', '/enterprise/'] }],
                    },
                    eagerness: 'immediate',
                },
            ],
        },
    },
    {
        page: '/free-trial/',
        schema: {
            prerender: [
                {
                    where: {
                        and: [{ href_matches: ['/price/', '/enterprise/', '/project-management-office/'] }],
                    },
                    eagerness: 'immediate',
                },
            ],
        },
    },
    {
        page: '/free-trial-vah/',
        schema: {
            prerender: [
                {
                    where: {
                        and: [{ href_matches: ['/price/', '/enterprise/', '/project-management-office/'] }],
                    },
                    eagerness: 'immediate',
                },
            ],
        },
    },
    {
        page: '/price/',
        schema: {
            prerender: [
                {
                    where: {
                        and: [{ href_matches: ['/comparison-table/', '/', '/enterprise/'] }],
                    },
                    eagerness: 'immediate',
                },
            ],
        },
    },
    {
        page: '/tour/',
        schema: {
            prerender: [
                {
                    where: {
                        and: [{ href_matches: ['/price/', '/', '/features/'] }],
                    },
                    eagerness: 'immediate',
                },
            ],
        },
    },
];
